<template>
    <div>
        
      <div class="clearfix row py-2 mb-2 border-bottom">       
        <div class="col-sm-5 px-3 company-form-box-title">GF Reasons for Separation</div> 
        <div class="col-sm-4">  
            <div class="custom-search float-right w-100">              
                <b-input-group class="mb-0">
                    <b-input-group-prepend is-text>
                        <b-icon icon="search"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                </b-input-group>
            </div>
        </div>
        <div class=" col-sm-3 text-right pr-0">
            <b-button id="show-btn" class="mr-3" @click="addNew()">+ Add New</b-button>
        </div>
      </div>
  
      
      
      <table class="table dataTable"> 
        <thead>
            <tr class="table-head">
                
              <template v-for="column in columns">
                
                <th v-if="column.sort" @click="sortBy(column.name)" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"style="cursor:pointer;"><span>{{column.label}}</span></th>
                <th v-else><span>{{column.label}}</span></th>
  
              </template>
                              
                
                <th class="text-right">Actions</th>
            </tr>
        </thead>          
        
        <tbody>
            <!-- {{ paginatedData }} -->
            <tr class="hover-bg table-row mx-2" v-for="item in paginatedData" :key="item.id">
                <td>{{item.title}}</td>
                <td>{{item.details}}</td>
                <td>{{status[item.status].text }}</td>
                <td class="text-center"><template v-if="item.default_reason == 1"><b-icon icon="check-circle-fill" variant="success"></b-icon></template></td>
                <td>{{ review_list[item.review_needed].text }}</td>
                
                <td class="text-right position-relative">
                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                        <b-button-group >    
                                        
                            <!-- <b-button variant="outline-secondary"><b-icon icon="eye"></b-icon>View</b-button> -->

                            <b-button variant="outline-secondary"  @click="editData(item.id)">
                              <b-icon icon="pencil"></b-icon> Edit
                            </b-button>
                            <b-button variant="outline-secondary"  @click="showDetails(item.id)">
                              <b-icon icon="pencil"></b-icon> Show Details
                            </b-button>      
                            <b-button variant="outline-secondary" @click="setDefault(item.id, 1)"><b-icon icon="gear"></b-icon> Set Default</b-button>                       
                        </b-button-group>
                    </div>
                </td>
            </tr>
        </tbody>
      </table>
      <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
      <div class="row py-2 no-margin" v-else>
          <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
              <ul class="pagination b-pagination float-left mb-0 mt-1">
                  <li class="page-item disabled m-2">View</li>
                  <li class="page-item disabled">
                      <b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select>
                  </li>
                  <li class="page-item disabled m-2">per page. Total {{ paginatedData.length }} records found.</li>
              </ul>
              <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                  :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                  first-number last-number></b-pagination-nav>
          </div>

      </div>
      
  
      <b-modal id="bv-modal-gfsettl-policy-reason" size="lg" hide-footer title="Details">
        <b-form @submit.stop.prevent="onSubmit">
          <input type="hidden" v-model="fdata.id" name="id">
          
          <div class="col-md-6 float-left">
            <b-form-group id="title-group" label="Reason for Separation" label-for="title" class="required-field">
                <b-form-input id="title" name="title" v-model="fdata.title" v-validate="{ required: true, min: 3 , alpha_spaces: true }" :state="validateState('title')" aria-describedby="title-feedback" data-vv-as="Reason"></b-form-input>
                <b-form-invalid-feedback id="title-feedback">{{ veeErrors.first('title') }}</b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="col-md-6 float-right">
            <b-form-group id="status-group" label="Status" label-for="status" class="required-field">
                <b-form-select id="status" name="status" v-model="fdata.status" v-validate="{ required: true }" :options="status" :state="validateState('status')" aria-describedby="status-feedback" data-vv-as="Status"></b-form-select>
                <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status') }}</b-form-invalid-feedback>
            </b-form-group>
          </div>
          
          <div class="col-md-6 float-left">
         
            <b-form-group id="details-group" label="Description" label-for="details">
                <b-form-textarea id="details" name="details" rows="3" max-rows="6" no-resize v-model="fdata.details" v-validate="{ }" :state="validateState('details')" aria-describedby="details-feedback" data-vv-as="Details"></b-form-textarea>
                <b-form-invalid-feedback id="details-feedback"> {{ veeErrors.first('details') }} </b-form-invalid-feedback>
            </b-form-group>
        
          </div>

          <div class="col-md-6 float-right">
            <b-form-group id="review_needed-group" label="Review Needed" label-for="review_needed" class="required-field">
                <b-form-select id="review_needed" name="review_needed" v-model="fdata.review_needed" v-validate="{ required: true }" :options="review_list" :state="validateState('review_needed')" aria-describedby="review_needed-feedback" data-vv-as="Review"></b-form-select>
                <b-form-invalid-feedback id="review_needed-feedback">{{ veeErrors.first('review_needed') }}</b-form-invalid-feedback>
            </b-form-group>
          </div>
          
          <div class="full-width mt-2 text-center">
            <b-button type="submit" variant="primary">Submit</b-button>
           
          </div>
        </b-form>
  
      </b-modal>
  
      <b-modal id="bv-modal-gfsettl-policy-reason-slab" size="lg" dialog-class="w-1200" hide-footer title="GF Separation Policy Slabs">
        <gf-reasons-for-separation-slabs :reason="reason"></gf-reasons-for-separation-slabs>
      </b-modal>
  
    
    </div>
  </template>
  <script>
    export default{
        
        mounted() {
            // this.permission = this.$acl['attendance-policy'];
        },
        props: [],
        data(){    
          
          let sortOrders = {};
          let columns = [
                          {label: 'Reason for Separation', name: 'title' , sort:true},
                          {label: 'Dscription', name: 'details', sort:true},
                          {label: 'Status', name: 'status' },
                          {label: 'Default', name: 'default' },
                          {label: 'Needs Review', name: 'needs_review' },
                      ];
          columns.forEach((column) => {sortOrders[column.name] = -1;});
            
            return {
              
                blankmsg : 'Fetching data..',  
                datalist:[],
                showoverlay:false,
                fdata : {review: 0,},
                reason: 0,
                search:'',
                columns: columns,
                sortKey: 'title',
                sortOrders: sortOrders,
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                status: [                  
                    { value: "0", text: "Disabled" },
                    { value: "1", text: "Enable" },
                ], 

                review_list: [                  
                    { value: 0, text: "No" },
                    { value: 1, text: "Yes" },
                ],  
                
                data: [
                    { "id": 1, "title": "Standard Separation", "details": "5 years' continuous service as an Employee of the Bank. He/she will get 30 days' basic salary for every completed year of service or for a period of service exceeding 6-month, if his total tenure of service with the bank is minimum 05 years but less than 10 years; and 45 days' basic salary for every completed year of service or for a period of service exceeding 6-month, if his total tenure of service with the bank is minimum 10 years or more.", 
                        "status": 1, "default": "Yes", "needs_review": "No" }, 
                    { "id": 2, "title": "Retrenchment, Redundancy, Lay-Off", "details": "1 year's continuous service as an Employee of the Bank. He/she will get 30 days' basic salary for every completed year of service or for a period of service exceeding 6 month.",
                     "status": 1, "default": "No", "needs_review": "No" }
                ],

                length: 20,
            temp_length: 20,

            length_options:
                [
                    {value: 20, text: "20"},
                    {value: 50, text: "50"},
                    {value: 100, text: "100"}
                ],
              
            }
        },
       
        methods:{
          
          
            validateState(ref)
            {
                if(this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
                {
                  return !this.veeErrors.has(ref);
                }
                return null;
            },
            showDetails(id)
            {
              this.reason = id;
              this.$bvModal.show('bv-modal-gfsettl-policy-reason-slab');
            },
            
            resetForm()
            {
              this.fdata = {};
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
              this.resetForm();
              this.$bvModal.show('bv-modal-gfsettl-policy-reason');
            },
           
            getData: function()
            {            
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/gf/gf-policy-reason').then(function(response){
                                    
                  this.datalist = response.data;                  
                  if(this.datalist.length == 0)
                    this.blankmsg = "Nothing found.";
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            setDefault:function(x, y)
            {   
              if(!this.checkNet()) return false;                  
              this.showoverlay = true;
              let formData = new FormData();
              let currentObj = this;

              formData.append('id', x);
              formData.append('default_reason', y);
              axios.post(this.$api_url + '/gf/policy-reason-mark-default', formData).then(function(response){
                  if(response.data.success && response.data.data){
                      this.getData();
                      this.$bvToast.toast(response.data.message || 'Settings saved', {title: 'Success',variant: 'success',solid: true});
                  }else{
                      this.$bvToast.toast(response.data.message || 'An error occurred, please try again later', {title: 'Error!',variant: 'danger',solid: true});  
                  } 
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
                
            },
            editData:function(x)
            {   
              if(!this.checkNet()) return false;                  
              this.showoverlay = true;
              axios.get(this.$api_url+'/gf/gf-policy-reason/'+x ).then(function(response){
                  this.fdata = response.data;                  
                  this.$bvModal.show('bv-modal-gfsettl-policy-reason');
  
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
                
            },
            deleteData(id) {
                    if(!this.checkNet()) return false;
                    let currentObj = this;
  
                    this.$bvModal.msgBoxConfirm('Please confirm that you want to delete.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {                    
                    if(value)
                    {   
                      axios.delete(this.$api_url+'/pfsettl-policy-reason/'+id).then(function(response){
                        this.getData();
                          this.showoverlay = false;              
                          
                      }.bind(this))
                      .catch(function (error) 
                      {
                        
                          currentObj.showoverlay = false;
                          currentObj.serverError(error);
                      });
                    }
                })
                ;
            },
            
            
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay = true;
  
                    e.preventDefault();
                    let currentObj = this;
                    
                    let formData = new FormData();
                                        
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 
  
                    var url = this.$api_url+'/gf/gf-policy-reason';
  
                    if(this.fdata.id > 0)
                    {                    
                      url = url + '/'+this.fdata.id+'?_method=PUT';
                    }                  
  
                    axios.post(url, formData)
                      .then(function (response) 
                      {
                        this.getData();
                        if(response.data.success && response.data.data){
                            this.$bvToast.toast(response.data.message || 'Saved!', {title: 'Success',variant: 'success',solid: true});
                        }else{
                            this.$bvToast.toast(response.data.message || 'An error occurred, please try again later', {title: 'Error!',variant: 'danger',solid: true});  
                        } 
                        this.showoverlay = false;
                        this.resetForm();                          
                        this.$bvModal.hide('bv-modal-gfsettl-policy-reason');
                          
                      }.bind(this))
                      .catch(function (error) 
                      {                          
                        this.showoverlay = false;                        
                        currentObj.serverError(error);
                      });
  
                    
                });
            },
  
            
            
        },
        created: function(){
            
            this.getData();
            Fire.$on('reloadData', () => {this.getData()});
        },
        
  
        computed: 
          {
              filteredData() 
              {
                  let filtered_list = this.datalist;
                  if (this.search) 
                  {
                      filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                  
                      if(filtered_list.length == 0)
                          this.blankmsg = "Nothing found.";                
                  }
  
                  let sortKey = this.sortKey;
                  let order = this.sortOrders[sortKey] || 1;
                  if (sortKey) 
                  {
                      filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                              a = String(a[sortKey]).toLowerCase();
                              b = String(b[sortKey]).toLowerCase();
                              if (this.columns[index].type && this.columns[index].type === 'date') 
                              {
                                  return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                              } 
                              else if (this.columns[index].type && this.columns[index].type === 'number') 
                              {
                                  return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                              } 
                              else 
                              {
                                  return (a === b ? 0 : a > b ? 1 : -1) * order;
                              }
                          }
                      );
                  }
                  
                  return filtered_list;
              },
              paginatedData() 
              {     
                  return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
              },
              calculateWorkingHours() {
                if (!this.fdata.clockin || !this.fdata.clockout) {
                  this.fdata.work_time = 0;
                  return this.fdata.work_time;
                }
  
                const [inHours, inMinutes] = this.fdata.clockin.split(":").map(Number);
                const [outHours, outMinutes] = this.fdata.clockout.split(":").map(Number);
  
                // Create Date objects
                const clockInDate = new Date(0, 0, 0, inHours, inMinutes);
                const clockOutDate = new Date(0, 0, 0, outHours, outMinutes);
  
                // Calculate the difference in minutes
                const workedMinutes = (clockOutDate - clockInDate) / (1000 * 60);
  
                
                if(this.fdata.break_time > 0)
                {
                  // Subtract the break time
                  this.fdata.work_time = workedMinutes - this.fdata.break_time;                
                }
                else
                {
                  this.fdata.work_time = workedMinutes;
                }
  
                return this.fdata.work_time;
                
              },
              
          }
    }
  </script>
  